import { UIText2 } from '@cian/ui-kit/typography';
import cn from 'classnames';
import * as React from 'react';

import * as styles from './styles.css';
import { IBreadcrumb } from '../../types/listingOffers';

export interface IBreadcrumbsProps {
  breadcrumbs: IBreadcrumb[];
  className?: string;
  onBreadcrumbClick?(): void;
}

export function Breadcrumbs({ breadcrumbs, className, onBreadcrumbClick }: IBreadcrumbsProps) {
  return (
    <div className={cn(styles['root'], className)} itemType="http://schema.org/BreadcrumbList" itemScope>
      <ul>
        {breadcrumbs.map((breadcrumb, index) => (
          <li key={breadcrumb.url} itemProp="itemListElement" itemType="http://schema.org/ListItem" itemScope>
            <a href={breadcrumb.url} itemProp="item" onClick={onBreadcrumbClick}>
              <UIText2 display="inline" color="text-secondary-default" itemProp="name">
                {breadcrumb.title}
              </UIText2>
            </a>
            <meta itemProp="position" content={String(index + 1)} />
          </li>
        ))}
      </ul>
    </div>
  );
}

Breadcrumbs.displayName = 'Breadcrumbs';
